import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const HeaderCell = props => (
  <div className={classnames('rt-td--header', props.className)}>
    <div className="rt-td--header__label">{props.value}</div>
  </div>
);

HeaderCell.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
};

export const makeHeaderCell = className => props => <HeaderCell {...props} className={className} />;

export default HeaderCell;
